<template>
<div :class="modelli_class">
         <v-sheet class="montatura-sheet " :max-width="maxwidth">
               <pre v-show="debug" class="data-vetro develop-info"  style="bottom:500px; left:0;"> montatura {{montatura}} </pre>
          <v-slide-group v-model="model3" :class="p4x" show-arrows>
       
            <v-slide-item
              v-for="list in montatura"
              :key="list.FINITURASTRUTTURA"
              v-slot="{ active, toggle }"
            >
              <v-card
                :color="list.SELECTED ? 'a' : 'b'"
                class="no-shadow v-card-rompi"
                height="125"
                width="80"
                @click="toggle"
              >
                <v-row
                  class="fit-height flex_struttura"
                   v-on:mouseover="mouseover(( is_italian ) ? list.FINITURA_ITA : list.FINITURA_ENG, montatura_name)"
                    v-on:mouseleave="mouseleave()"
                  justify="center"
                  @click="onCardClickfinitura(list.FINITURASTRUTTURA)"
                >
          <!--       <VueCustomTooltip :label="( is_italian ) ? list.FINITURA_ITA : list.FINITURA_ENG" position="is-bottom"> -->
                   
                                   <img
                    :class="list.SELECTED ? 'active_image' : 'not_active_image_m'"
                    class="img_montatura"
                    v-bind:src="url + 'risorse/struttura/' + list.FINITURASTRUTTURA + '.jpg'"
                  />
            <!--       </VueCustomTooltip> -->
                  <p
                    class="pesante_scuro vetro_testo"
                    :class="list.SELECTED ? 'opaco_no margin_custom_montatura' : 'opaco_si margin_custom_montatura'"
                  >
                    {{ list.FINITURASTRUTTURA }}
                  </p>
                      <p
                    class="montatura_weoru montatura_testo_sotto_tessera "
                    :class="list.SELECTED ? 'mostrare_finitura_italiano' : 'non_mostrare_finitura_italiano'"
                  >
                    {{ list.FINITURA_ITA }}
                  </p>
                          <p
                    class="montatura_weoru montatura_testo_sotto_tessera "
                    :class="list.SELECTED ? 'mostrare_finitura_inglese' : 'non_mostrare_finitura_inglese'"
                  >
                    {{ list.FINITURA_ENG }}
                  </p>
                  <v-scale-transition> </v-scale-transition>
                </v-row>
                


              </v-card>
            </v-slide-item>
          </v-slide-group>
      <!--      <p class="montatura_weoru"> {{ montatura_name }} </p> -->
        </v-sheet>
</div>
</template>
<script>
import checkLanguage from "../classes/class_check_language";

export default {
    name: 'montatura',
    computed: {
        maxwidth (){
      try {
           let width = document.getElementById('dfnweio3').offsetWidth;
 
        return width;
      } catch (error) {
        let width = 800;
        return width;
      }
   
    },

        montatura () {
          try{
          this.$store.state.products_store.FINITURASTRUTTURA_ARRAY.forEach(finitura => {
            if (this.is_italian){
                if (finitura.SELECTED){
                    this.montatura_name = finitura.FINITURA_ITA;
                }
            }else{
            if (finitura.SELECTED){
                    this.montatura_name = finitura.FINITURA_ENG;
                }
              
            }
          });
               } catch (error) {
            console.info(error);
        }
            return this.$store.state.products_store.FINITURASTRUTTURA_ARRAY;
        },
          debug(){
      return this.$store.state.products.debug;
    },
       p4x(){
      try {
        let pixels = window.innerWidth;
        if (pixels>630){
          return '  pa-4-2 ';
        }
        return ' mobile ';
      } catch (error) {
        
        return ' pa-4-2';
      }
    },
    },
    data: ( ) => ({
        model3:[],
        montatura_name : '',
        url : '',
        visualize : '',
        modelli_class : '',
       
    }),
    methods: {
        onCardClickfinitura(MONTATURA){
        this.$store.commit("click_on_montatura", MONTATURA);
        console.info('montatura', MONTATURA);
        },
        mouseover(value){
          this.visualize = this.montatura_name;
          this.montatura_name = value;
          this.hover = 'over';
        },
        mouseleave(){
          this.montatura_name = this.visualize;
          this.hover = 'leave';
        },
      myEventHandler() {
        try {
          let width = window.innerWidth;
        let count = this.montatura.length;
        if ( count == 1){
          this.modelli_class = 'only_one';
        }
     
        if (count <=5){
          this.modelli_class = 'only_one';
        }else{
          this.modelli_class = '';
        }

          if (width >1150){
            if (count <= 5  ){
              this.modelli_class = 'only_one';
            }
          }
          
        } catch (error) {
          console.info('error on resize', error);
        }
    // your code for handling resize...
  },
    },
       mounted() {
            this.url = window.location.hostname;
            // questa funzione è stata aggiunta perche non cambiava l'immagine 
            // quando andavi ad aprire un elmento con lo sku che ti dicevano loro
            let l = this.$store.state.products_store.MONTATURASET;
            if (l){
              this.onCardClickfinitura(l);
            }
            // fine funzione issue
           if (this.url.toString().includes('localhost')){
             this.url = 'http://localhost/vistosiwoocommerce/';

           } else {
              this.url = 'https://'+this.url+'/';
           }
                let c = new  checkLanguage();
                this.is_italian = c.is_italian();
                 setTimeout(() => {
                   this.myEventHandler();
                 }, 500);
              
       }
}
</script>
<style>
.not_active_image_m{
  opacity:0.5;
}
.flex_struttura img{
  margin:5px;
  padding:5px;
  width:75px;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}
 .pa-4-2 {
    padding: 16px!important;
    padding-left: 0px!important;
    padding-bottom: 0 !important;
    height: 120px;
}
.montatura_weoru{
  font-weight: 500  !important;
}
.non_mostrare_finitura_inglese, .non_mostrare_finitura_italiano {
  display:none !important;
}
html[lang=it-IT] .mostrare_finitura_inglese {
  display:none !important;
}
html[lang=en-US] .mostrare_finitura_italiano {
  display:none !important;
}
.list-finiture-montature .v-slide-group__wrapper {
    height: 146px !important;
}
.list-finiture-montature .v-slide-group__content{
  min-width: 500px !important;
}
.montatura_testo_sotto_tessera{
      margin-left: 11px !important;
    margin-top: -6px !important;
    min-width: 150px !important;
    overflow: visible;
    z-index: 2;
}
</style>